"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerStyleToFontVariant = void 0;
const types_1 = require("../../types");
const headerStyleToFontVariant = (headerStyle) => {
    if (headerStyle.includes(types_1.HeaderFontStyle.bold) &&
        headerStyle.includes(types_1.HeaderFontStyle.italic)) {
        return types_1.FontVariant.boldItalic;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.bold)) {
        return types_1.FontVariant.bold;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic)) {
        return types_1.FontVariant.italic;
    }
    //optimize this
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_100)) {
        return types_1.FontVariant.weight_100;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_200)) {
        return types_1.FontVariant.weight_200;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_300)) {
        return types_1.FontVariant.weight_300;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_500)) {
        return types_1.FontVariant.weight_500;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_600)) {
        return types_1.FontVariant.weight_600;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_700)) {
        return types_1.FontVariant.weight_700;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_800)) {
        return types_1.FontVariant.weight_800;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_900)) {
        return types_1.FontVariant.weight_900;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_100)) {
        return types_1.FontVariant.italic_100;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_200)) {
        return types_1.FontVariant.italic_200;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_300)) {
        return types_1.FontVariant.italic_300;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.weight_500)) {
        return types_1.FontVariant.italic_500;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_600)) {
        return types_1.FontVariant.italic_600;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_700)) {
        return types_1.FontVariant.italic_700;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_800)) {
        return types_1.FontVariant.italic_800;
    }
    if (headerStyle.includes(types_1.HeaderFontStyle.italic_900)) {
        return types_1.FontVariant.italic_900;
    }
    return types_1.FontVariant.regular;
};
exports.headerStyleToFontVariant = headerStyleToFontVariant;
